import React, { FC } from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from 'hooks/useStores';
import Button from 'ati-ui-react/components/Button';
import Link from 'ati-ui-react/components/Link';
import cn from 'classnames';
import getEnvironDomain from 'utils/getEnvironDomain';

import { ReportButtonContainer } from './ReportButtonStyles';

interface IReportButton {
  forGovNumVin?: boolean;
}

const ReportButton: FC<IReportButton> = observer(({ forGovNumVin }) => {
  const {
    checksStore: {
      buyingFullReportStatus,
      priceGovNumVin,
      priceReport,
      statusGettingUniqueNumbersAccess,
      buyFullReport,
      getUniqueNumbersAccess,
      setCloseShowPopupGovNumVin,
    },
    advertsStore: {
      currentAdvert,
      // @ts-ignore
      currentAdvert: { _id },
    },
    profileStore: { user, balance },
  } = useStores();

  const renderBuyPrice = forGovNumVin ? priceGovNumVin : priceReport;
  // @ts-ignore
  const isEnoughMoney = balance >= renderBuyPrice;
  const isForbidVirtualAccountOperations = user.profile.contact.forbid_virtual_account_operations;

  const isLoadingButton =
    buyingFullReportStatus.isRequest || statusGettingUniqueNumbersAccess.isRequest;

  const isdisabledButton =
    buyingFullReportStatus.isRequest ||
    statusGettingUniqueNumbersAccess.isRequest ||
    isForbidVirtualAccountOperations;

  const btnDescriptionClassName = cn('btn-description', !isEnoughMoney && 'first');
  const firstLineClassName = cn(
    'first-line',
    (!isEnoughMoney || isForbidVirtualAccountOperations) && 'red',
  );
  const secondLineClassName = cn('second-line', isEnoughMoney && 'gray small');

  const handleClickActionBtn = async (e: any) => {
    if (isEnoughMoney) {
      e.preventDefault();
      // @ts-ignore
      await buyFullReport(currentAdvert?._id, 'sidebar');
      if (buyingFullReportStatus.isSuccess) {
        setCloseShowPopupGovNumVin();
      }
    }
  };

  const onHandleBuyGovNumVin = async (): Promise<void> => {
    await getUniqueNumbersAccess({ advert_id: _id });

    if (statusGettingUniqueNumbersAccess.isSuccess) {
      setCloseShowPopupGovNumVin();
    }
  };

  const renderReportButtonDescription = () => {
    if (!isEnoughMoney && !isForbidVirtualAccountOperations) {
      return 'Пополнить счет';
    }

    if (forGovNumVin) {
      return 'Оплатить';
    }

    return 'Купить полный отчет';
  };

  const operationsDescription = () => {
    if (isForbidVirtualAccountOperations) {
      return 'Нет доступа для работы с виртуальным счетом.';
    }

    if (!isEnoughMoney) {
      return 'На вашем счете не хватает средств.';
    }

    return `${renderBuyPrice} ат. к оплате`;
  };

  const operationSubDescription = () => {
    if (isForbidVirtualAccountOperations) {
      return (
        <Link
          href={`https://help.${getEnvironDomain()}/personal-account`}
          type="external"
          rel="noopener noreferrer"
          target="_blank"
          small
        >
          Подробнее про виртуальные счета контактов
        </Link>
      );
    }

    if (!isEnoughMoney) {
      return `Для ${
        forGovNumVin ? 'открытия VIN/гос.номера' : 'оплаты проверки'
      } пополните счет на\u00A0${renderBuyPrice}\u00A0атисов.`;
    }

    return 'спишутся с вашего счёта в АТИ';
  };

  return (
    <ReportButtonContainer>
      <Button
        onClick={forGovNumVin ? onHandleBuyGovNumVin : handleClickActionBtn}
        className={cn('action-btn', !isEnoughMoney && 'second')}
        isLoading={isLoadingButton}
        disabled={isdisabledButton}
        href={
          !isEnoughMoney &&
          !isdisabledButton &&
          `https://billing.${getEnvironDomain()}/addinvoice?option=4`
        }
        target="_blank"
      >
        {renderReportButtonDescription()}
      </Button>
      <div className={btnDescriptionClassName}>
        <div className={firstLineClassName}>{operationsDescription()}</div>
        <div className={secondLineClassName}>{operationSubDescription()}</div>
      </div>
    </ReportButtonContainer>
  );
});

export default ReportButton;
